<div class="template-preview-container" *ngIf="!isNotDialog">
  <div class="preview-header">
    <h2>Template Preview</h2>
    <button [attr.guide]="'template-preview-btn-1-1' + '__' + sanitizedUrl" *ngIf="!isNotDialog && dialogRef" mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="template-info">
    <div class="info-row">
      <span class="info-label">Name:</span>
      <span class="info-value">{{templateData.name}}</span>
    </div>
    <div class="info-row">
      <span class="info-label">Category:</span>
      <span class="info-value">{{templateData.category}}</span>
    </div>
    <div class="info-row">
      <span class="info-label">Language:</span>
      <span class="info-value">{{templateData.language}}</span>
    </div>
    <div class="info-row">
      <span class="info-label">Status:</span>
      <span class="info-value" [ngClass]="{
          'approved': templateCurrentStatus === 'APPROVED',
          'rejected': templateCurrentStatus === 'REJECTED',
          'pending': templateCurrentStatus === 'PENDING'
        }">{{templateCurrentStatus}}</span>
    </div>
  </div>

  <div class="whatsapp-preview">
    <div class="whatsapp-message">
      <!-- Header Preview -->
      <ng-container *ngIf="getHeaderComponent() as header">
        <!-- Image Header -->
        <div *ngIf="header.format === 'IMAGE'" class="message-header">
          <div class="media-preview">
            <img *ngIf="headerImageUrl" [src]="headerImageUrl" class="preview-image" alt="Header image"
              style="max-width: 100%; border-radius: 4px; object-fit: cover;">
            <div *ngIf="!headerImageUrl" class="media-placeholder">
              <i class="fas fa-image"></i>
              <span>Image</span>
            </div>
          </div>
        </div>
        <div *ngIf="header.format === 'VIDEO'" class="message-header">
          <div class="media-preview">
            <div class="media-placeholder">
              <i class="fas fa-image"></i>
              <span>VIDEO</span>
            </div>
          </div>
        </div>
        <div *ngIf="header.format === 'LOCATION'" class="message-header">
          <div class="media-preview">
            <div class="media-placeholder">
              <i class="fas fa-map-marker-alt"></i>
              <span>LOCATION</span>
            </div>
          </div>
        </div>

        <div *ngIf="header.format === 'DOCUMENT'" class="message-header">
          <div class="media-preview">
            <div class="media-placeholder">
              <i class="fas fa-image"></i>
              <span>DOCUMENT</span>
            </div>
          </div>
        </div>

        <!-- Text Header -->
        <div *ngIf="header.format === 'TEXT'" class="text-header">
          {{header.text}}
        </div>
      </ng-container>

      <!-- Body Preview -->
      <div *ngIf="getBodyComponent() as body" class="message-body" [innerHTML]="formatWhatsAppText(body.text)"></div>

      <!-- Footer Preview -->
      <div *ngIf="getFooterComponent() as footer" class="message-footer">
        {{footer.text}}
      </div>

      <!-- Buttons Preview -->
      <div *ngIf="getButtonsComponent() as buttons" class="message-buttons">
        <div *ngFor="let button of buttons.buttons; let i = index" class="button-preview">
          <div *ngIf="i < 3" class="button-item">
            <i *ngIf="button.type === 'QUICK_REPLY'" class="fas fa-reply"></i>
            <i *ngIf="button.type === 'PHONE_NUMBER'" class="fas fa-phone-alt"></i>
            <i *ngIf="button.type === 'URL'" class="fas fa-external-link-alt"></i>
            <span *ngIf="button.type === 'COPY_CODE'">
              <i class="fas fa-copy"></i> Copy Code
            </span>
            <span>{{ button.text }}</span>
          </div>
        </div>
        <div *ngIf="buttons.buttons?.length > 3" class="see-all-button">
          <i class="fas fa-ellipsis-h"></i> See all options
        </div>
      </div>
    </div>
  </div>
</div>

<div class="template-preview-container" *ngIf="isNotDialog">
  <div class="main-preview-container">
    <!-- <span>Message Preview</span> -->
    <div class="whatsapp-preview">
      <div class="whatsapp-message">
        <!-- Header Preview -->
        <ng-container *ngIf="getHeaderComponent() as header">
          <!-- Image Header -->
          <div *ngIf="header.format === 'IMAGE'" class="message-header">
          <div class="media-preview">
            <!-- Show newly uploaded image with priority; fall back to original headerImageUrl -->
            <img *ngIf="uploadedMediaUrl || headerImageUrl"
              [src]="uploadedMediaUrl || headerImageUrl"
              class="preview-image" alt="Header image"
              style="max-width: 100%; border-radius: 4px; object-fit: cover;">
            <div *ngIf="!uploadedMediaUrl && !headerImageUrl" class="media-placeholder">
              <i class="fas fa-image"></i>
              <span>Image</span>
            </div>
          </div>
        </div>
           <div *ngIf="header.format === 'VIDEO'" class="message-header">
          <div class="media-preview">
            <div class="media-placeholder">
              <i class="fas fa-image"></i>
              <span>VIDEO</span>
            </div>
          </div>
        </div>
          
          <div *ngIf="header.format === 'LOCATION'" class="message-header">
            <div class="media-preview">
              <div class="media-placeholder">
                <i class="fas fa-map-marker-alt"></i>
                <span>LOCATION</span>
              </div>
            </div>
          </div>
          <div *ngIf="header.format === 'DOCUMENT'" class="message-header">
          <div class="media-preview">
            <div class="media-placeholder">
              <i class="fas fa-image"></i>
              <span>DOCUMENT</span>
            </div>
          </div>
        </div>


          <!-- Text Header -->
          <div *ngIf="header.format === 'TEXT'" class="text-header">
            {{header.text}}
          </div>
        </ng-container>

        <!-- Body Preview -->
        <div *ngIf="getBodyComponent() as body" class="message-body" [innerHTML]="formatWhatsAppText(body.text)"></div>

        <!-- Footer Preview -->
        <div *ngIf="getFooterComponent() as footer" class="message-footer">
          {{footer.text}}
        </div>

        <!-- Buttons Preview -->
        <div *ngIf="getButtonsComponent() as buttons" class="message-buttons">
          <div *ngFor="let button of buttons.buttons; let i = index" class="button-preview">
            <div *ngIf="i < 3" class="button-item">
              <i *ngIf="button.type === 'QUICK_REPLY'" class="fas fa-reply"></i>
              <i *ngIf="button.type === 'PHONE_NUMBER'" class="fas fa-phone-alt"></i>
              <i *ngIf="button.type === 'URL'" class="fas fa-external-link-alt"></i>
              <span *ngIf="button.type === 'COPY_CODE'">
                <i class="fas fa-copy"></i> Copy Code
              </span>
              <span>{{ button.text }}</span>
            </div>
          </div>
          <div *ngIf="buttons.buttons?.length > 3" class="see-all-button">
            <i class="fas fa-ellipsis-h"></i> See all options
          </div>
        </div>
      </div>
    </div>
  </div>

</div>